$('.btn').each( function() {
    $(this).prepend('<div class="btn__arrow"><i class="icon icon-arrow-right"></i></div>');
});
